import React, { Component } from 'react'
import $ from 'jquery'
import * as Common from '../CommonControlls/CommonJs'
import MainLayout from '../CommonControlls/MainLayout'
import Topmenu from '../CommonControlls/Topmenubar'
import { connect } from 'react-redux'
import AlertModal from '../CommonControlls/AlertModal'
import Table from '../CommonControlls/TableRendrer'
import jsPDF from 'jspdf'

const mapStateToProps = (store) => {
  return store
}

const mapDispatchToProps = (dispatch) => {
  return {
    ShowAlert: (Settings) => {
      dispatch({ type: 'UpdateAlert', payload: Settings })
    },
    ShowLoader: (Isloading) => {
      dispatch({ type: 'UpdateLoader', payload: Isloading })
    },
  }
}

class ActivityLogs_List extends Component {
  constructor(props) {
    super(props)
    this.state = {
      Save: true,
      Update: true,
      Delete: true,
      View: true,

      alertModalData: {
        title: '',
        message: '',
        First_Callback: () => {},
        Second_Callback: () => {},
        type: 1,
      },

      // Table
      data: [],
      page: 1,
      sizePerPage: 15,
      TotalRecord: 0,
      loading: false,
    }
  }

  componentWillMount() {
    if (this.props.UserAuthentication.AuthToken === '') {
      this.props.history.push('/Login')
    }
  }

  componentDidMount() {
    Common.AddClassToMenueLink(
      'MenuLink_Activity',
      true,
      'MenuParentLink_Security',
    )
    this.PopulateTable()
  }

  handleTableChange = (
    type,
    { page, sizePerPage, filters, sortField, sortOrder, cellEdit },
  ) => {
    if (type === 'sort') {
      let result = this.state.data
      // Handle column sort
      if (sortOrder === 'asc') {
        result = result.sort((a, b) => {
          if (a[sortField] > b[sortField]) {
            return 1
          } else if (b[sortField] > a[sortField]) {
            return -1
          }
          return 0
        })
      } else {
        result = result.sort((a, b) => {
          if (a[sortField] > b[sortField]) {
            return -1
          } else if (b[sortField] > a[sortField]) {
            return 1
          }
          return 0
        })
      }
      return
    }
    this.setState(
      {
        page,
        sizePerPage,
      },
      () => {
        this.PopulateTable()
      },
    )
  }

  ExportData = (size) => {
    this.setState({ loading: true })

    const Parameters = {
      pageSize: this.state.TotalRecord,
      pageNumber: this.state.page,
    }

    Common.Ajax(
      this.props.UserAuthentication.AuthToken,
      'Get',
      false,
      Common.APILinks.GetActivityLog,
      Parameters,
      (resp) => {
        this.setState({ loading: false })
        if (resp.status) {
          this.setState({
            data: this.prepareTableData(resp.data.reverse()),
            TotalRecord: resp.totalRecord,
            exportLoading: false
          })
          $('.react-bs-table-csv-btn').click()
          this.PopulateTable()
        } else {
          this.props.ShowAlert({ Type: 0, Msg: resp.message })
          setTimeout(function () {
            $('#Alertmsgbtn').click()
          }, 50)
        }
      },
      (error) => {
        $('#FormSearchBtn').prop('disabled', false)
        this.setState({ loading: false })
        this.props.ShowAlert({
          Type: 0,
          Msg: 'Something went wrong, please try again.',
        })
        setTimeout(function () {
          $('#Alertmsgbtn').click()
        }, 50)
      },
    )
  }

  PopulateTable = () => {
    this.setState({ loading: true })

    var Parameters = {
      pageSize: this.state.sizePerPage,
      pageNumber: this.state.page,
    }

    Common.Ajax(
      this.props.UserAuthentication.AuthToken,
      'Get',
      false,
      Common.APILinks.GetActivityLog,
      Parameters,
      (resp) => {
        this.setState({ loading: false })
        if (resp.status) {
          this.setState({
            data: this.prepareTableData(resp.data.reverse()),
            TotalRecord: resp.totalRecord,
          })
        } else {
          this.props.ShowAlert({ Type: 0, Msg: resp.message })
          setTimeout(function () {
            $('#Alertmsgbtn').click()
          }, 50)
        }
      },
      (error) => {
        $('#FormSearchBtn').prop('disabled', false)
        this.setState({ loading: false })
        this.props.ShowAlert({
          Type: 0,
          Msg: 'Something went wrong, please try again.',
        })
        setTimeout(function () {
          $('#Alertmsgbtn').click()
        }, 50)
      },
    )
  }

  prepareTableData = (data = []) =>
    data.map((row, index) => ({ ...row, index, showMore: false }))

  showMore = (id) => {
    const data = [...this.state.data]
    data.forEach((row) => {
      if (+row.id === +id) {
        row.showMore = !row.showMore
      }
    })
    this.setState({ data })
  }

  render() {
    const CellMenu = (cell, row) => {
      let style = {}
      if (!row.showMore)
        style = {
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          width: 200,
        }
      return (
        <span style={style}>
          {row.showMore
            ? JSON.stringify(JSON.parse(row.data), null, 2)
            : JSON.stringify(JSON.parse(row.data), null, 2).substring(0, 25)}
          <span
            style={{ cursor: 'pointer' }}
            className="text-primary"
            onClick={() => this.showMore(row.id)}
          >
            {` Show ${row.showMore ? 'less' : 'more'}`}
          </span>
        </span>
      )
    }

    const columns = [
      {
        dataField: 'id',
        text: 'ID',
        sort: true,
      },
      {
        dataField: 'tableName',
        text: 'Table Name',
        sort: true,
      },
      {
        dataField: 'eventDateTime',
        text: 'Event Date',
        sort: true,
        formatter: (cell, row) => {
          const myDate = new Date(row.eventDateTime)
          return (
            <div style={{ width: 120 }}>
              {myDate.getDate()}-{myDate.getMonth()}-{myDate.getFullYear()}{' '}
              {myDate.getHours()}:{myDate.getMinutes()}
            </div>
          )
        },
      },
      {
        dataField: 'userName',
        text: 'Event Performed By',
        sort: true,
      },
      {
        dataField: 'roleName',
        text: 'Performed By Role',
        sort: true,
      },
      {
        dataField: 'eventType',
        text: 'Event Type',
        sort: true,
      },
      {
        dataField: 'totalCount',
        text: 'Total Count',
        sort: true,
      },
      {
        dataField: 'data',
        text: 'Data',
        // headerStyle: (colum, colIndex) => { return { minWidth: 120 } },
        formatter: CellMenu,
        csvExport: true,
      },
    ]

    return (
      <div>
        <MainLayout />
        <AlertModal {...this.state.alertModalData} />
        <div id="right-panel" class="right-panel">
          {/* <Topmenu/>               */}
          <Topmenu
            PageTitle="Activity Logs"
            isShowAddBtn={false}
            AddBtnLabel="Add Role"
            AddBtnLink="/Roles_Add"
          />

          <div class="content">
            <div class="PageHeader_Container">
              <h2 class="Pageheading">Activity</h2>
            </div>

            <div class="card">
              <div class="card-body">
                {/* <div class="TableTop_Buttons">
                        <span class="TableExport_button"><i class="fa fa-download" aria-hidden="true"></i> Export</span>
                    </div> */}

                <Table
                  keyField="id"
                  data={this.state.data}
                  page={this.state.page}
                  sizePerPage={this.state.sizePerPage}
                  totalSize={this.state.TotalRecord}
                  onTableChange={this.handleTableChange}
                  isPagination
                  columns={columns}
                  loading={this.state.loading}
                  RefreshTable={this.PopulateTable}
                  changeSizePerPage={(size) => {
                    setTimeout(() => {
                      this.setState({
                        exportLoading: true,
                      })
                      this.ExportData(size)
                    }, 100)
                  }}
                  exportLoading={this.state.exportLoading}
                  exportAllowed
                  showPdf={false}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ActivityLogs_List)
